import React, { useState, useEffect } from "react";
import validator from "validator";
import { useDispatch } from "react-redux";
import { getForm } from "../../actions/forms";
import axiosInstance from "../../utils/config";
import "./style.css";

function ForgotPassword() {
  const dispatch = useDispatch(),
    dependency = "Dependency",
    [resetEmail, setResetEmail] = useState(""),
    [errors, setErrors] = useState([]),
    [successMsg, setSuccessMsg] = useState(""),
    onInput = (e) => {
      setResetEmail(e.target.value);
    },
    onSubmit = (e) => {
      e.preventDefault();
      if (resetEmail.length === 0) setErrors(["The email field is required."]);
      else if (!validator.isEmail(resetEmail))
        setErrors(["Please provide a valid email."]);
      else {
        setErrors([]);
        setSuccessMsg("Now check your email for the password reset link.");
        axiosInstance
          .post("/sendResetLink", { Email: resetEmail })
          .then((res) => {
            return null;
          })
          .catch((err) => {
            console.log("Error.....", err);
            setErrors(["Waiting for connection."]);
          });
      }
    };
  useEffect(() => {
    document.title = "Ski Design | Forgot Password";
  }, [dependency]);
  return (
    <div className="form-container">
      <div className="upper-rotated-container"></div>
      <div className="login-form-cont form-cont position-relative">
        <h2 className="form-header">Forgot Password</h2>
        {errors.length > 0 && (
          <div className="alert alert-danger text-center" role="alert">
            {errors[0]}
          </div>
        )}
        {successMsg.split("").length > 0 && (
          <div className="alert alert-success text-center" role="alert">
            {successMsg}
          </div>
        )}
        <p className="under-header mb-5">Forgot Password. Change!</p>
        <form
          className="d-flex flex-column align-items-center justify-content-center"
          onSubmit={(e) => onSubmit(e)}
        >
          <input
            type="email my-2"
            required
            placeholder="Email"
            className="email"
            onInput={(e) => onInput(e)}
            value={resetEmail}
          />
          <button className="login-submit-btn mt-5 mb-3">Forgot</button>
          <p className="text-center" style={{ color: "#32403B" }}>
            Remember Password?{" "}
            <span
              className="link-text"
              onClick={() => dispatch(getForm("login"))}
            >
              Log In
            </span>
          </p>
        </form>
      </div>
      <div className="lower-rotated-container"></div>
    </div>
  );
}

export default ForgotPassword;
